import BaseException from './BaseException';

export default class ErrorResponseException extends BaseException {
  readonly name = 'ErrorResponseException';
}
